import ScannerShipment from './shipment';

const routes = [
  {
    path: '/scanner/shipment',
    component: ScannerShipment,
    action: ['manage'],
    service: ['nvo.tms.delivery'],
  },
];

export default routes;
